import { render, staticRenderFns } from "./Medals.vue?vue&type=template&id=36440f37&scoped=true"
import script from "./Medals.vue?vue&type=script&lang=js"
export * from "./Medals.vue?vue&type=script&lang=js"
import style0 from "./Medals.vue?vue&type=style&index=0&id=36440f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36440f37",
  null
  
)

export default component.exports